import * as React from "react";
export const AppLayout = ({ content, permanent, aside, menu, }) => {
    return (React.createElement("div", { className: "flex min-h-screen w-full flex-col bg-muted/40" },
        aside,
        React.createElement("div", { className: "flex flex-col flex-1 main-content-area" },
            menu,
            React.createElement("main", { className: "flex flex-1 flex-row p-4 lg:px-6 lg:py-0 max-w-[100vw]" }, content),
            permanent)));
};
//# sourceMappingURL=AppLayout.js.map